import React, { ReactNode } from "react";

export const Group: React.FC<{
  className?: string;
  children: ReactNode;
}> = props => {
  return (
    <div className={`form-group ${props.className ?? ""}`}>
      {props.children}
    </div>
  );
};
